export default "__VITE_ASSET__B2uyTN4z__"